/*
  EOH - CUSTOM
  This file contains some customisations
  - Fetching the product accordions from the PDP when a specific block has been added to the main section
*/
if (!customElements.get('quick-view-modal')) {
  customElements.define(
    'quick-view-modal',
    class QuickViewModal extends DrawerComponent {
      constructor() {
        super();

        this._classes = {
          loaded: 'quick-view-loaded',
        };
        this.drawerBody = this.querySelector(this.selector);
      }

      get selector() {
        return '.quick-view__content';
      }

      get sourceSelector() {
        return '#MainProduct-quick-view__content';
      }

      get requiresBodyAppended() {
        return !(Shopify.designMode && this.closest('.section-group-overlay-quick-view'));
      }

      shouleBeShow() {
        const sectionId = this.getProductQuickViewSectionId();
        return typeof sectionId === 'string';
      }

      prepareToShow() {
        super.prepareToShow();
        this.quickview();
      }

      handleAfterShow() {
        super.handleAfterShow();
        document.dispatchEvent(
          new CustomEvent('quick-view:open', {
            detail: { productUrl: this.dataset.productUrl },
          })
        );
      }

      handleAfterHide() {
        super.handleAfterHide();
        const drawerContent = this.querySelector(this.selector);
        drawerContent.innerHTML = '';
        this.classList.remove(this._classes.loaded);
      }

      getProductQuickViewSectionId() {
        let sectionId = FoxTheme.QuickViewSectionId || false;

        if (!sectionId) {
          // Get section id from overlay groups.
          const productQuickView = document.querySelector('.section-group-overlay-quick-view');
          if (productQuickView) {
            sectionId = FoxTheme.utils.getSectionId(productQuickView);
          }

          // Cache for better performance.
          FoxTheme.QuickViewSectionId = sectionId;
        }

        return sectionId;
      }

      async quickview() {
        const drawerContent = this.querySelector(this.selector);
        const sectionId = this.getProductQuickViewSectionId();
        const sectionUrl = `${this.dataset.productUrl.split('?')[0]}?section_id=${sectionId}`;
        try {
          const sectionResponse = await fetch(sectionUrl);
          const sectionResponseText = await sectionResponse.text();
          const productElement = new DOMParser().parseFromString(sectionResponseText, 'text/html').querySelector(this.sourceSelector);
          this.setInnerHTML(drawerContent, productElement.content.cloneNode(true));
          // check to see if the product accordion block has been added
          // if it has, retrieve the product accordions from the full product page
          const productAccordionContainerEl = this.querySelector('[data-product-accordions]');
          if(productAccordionContainerEl) {
            const fullProductResponse = await fetch(this.dataset.productUrl);
            const fullProductResponseText = await fullProductResponse.text();
            const productPageElement = new DOMParser().parseFromString(fullProductResponseText, 'text/html');
            const collapsibleTabEls = productPageElement.querySelectorAll('.product__info-container .product__block--collapsible_tab');
            if(collapsibleTabEls) {
              collapsibleTabEls.forEach((tab) => {
                productAccordionContainerEl.appendChild(tab.cloneNode(true));
              });
            }
          }

          FoxTheme.a11y.trapFocus(this, this.focusElement);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          setTimeout(() => {
            this.classList.add(this._classes.loaded);
          }, 300);

          document.dispatchEvent(
            new CustomEvent('quick-view:loaded', {
              detail: { productUrl: this.dataset.productUrl },
            })
          );
        } catch (error) {
          console.error('Error fetching section:', error);
        }
      }

      setInnerHTML(element, innerHTML) {
        element.innerHTML = '';
        element.appendChild(innerHTML);
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      disconnectedCallback() {
        super.disconnectedCallback();
        this.handleAfterHide();
      }
    }
  );
}
